import { initPageTier } from '@/pages/_shared/tier-utils'
import { initTier1NotCheckout } from '@/pages/_shared/not-checkout/tier1'

export const initTier1 = async (): Promise<void> => {
  await initPageTier(1, [initTier1NotCheckout])
  // `webpackPrefetch` prefetches the next tier at `Lowest` network priority when the current tier is loaded,
  // even before the following `import()` is executed.
  import(
    /* webpackChunkName: '@/email-preferences/tier2', webpackPrefetch: true */ './tier2'
  ).then(({ initTier2 }) => initTier2())
}

initTier1()
